import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var ScrollTopCss = i`
  #scrolltop {
    font-size: 1.5rem;
    width: var(--isceco-space-500);
    height: var(--isceco-space-500);
    border-radius: 50%;
    box-shadow: none;
    cursor: pointer;
    border: none;
    background-color: var(--isceco-color-blue-500);
    color: var(--isceco-color-white-500);
    padding: 0;
    position: fixed;
    right: var(--isceco-space-200);
    bottom: var(--isceco-space-400);
    transition: all 0.5s;
  }

  #scrolltop.hidden {
    bottom: -100%;
  }

  #scrolltop > i {
    margin: 0 !important;
  }

  #scrolltop:hover {
    background-color: var(--isceco-color-blue-700);
  }
`;
export { ScrollTopCss as default };
